import React, { useLayoutEffect, Fragment } from 'react';
import { Hero } from '.';
import { Outro } from '../common';
import { Document } from 'components';

export function Features(props) {
  useLayoutEffect(props.setReady, []);
  return (
    <Fragment>
      <Document.Title>Features</Document.Title>
      <Document.Description>Complete and structured personal development and online coaching program. Ensure effective focused action and continuous self-improvement.</Document.Description>
      <Hero {...props} />
      <Outro />
    </Fragment>
  );
}
